import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';

const Erhvervsraadgivning = () => {
  const competencies = [
    "Regnskabsanalyse med fokus på indtjening, likviditet og kapitalstruktur",
    "Optimering af balancen, herunder gæld og overskudslikviditet",
    "Investeringsforslag til placering af virksomhedsmidler eller salgsprovenue",
    "Forhandling med banker og realkreditinstitutter om bedre vilkår",
    "Rådgivning om udbyttepolitik og sammenhæng med privatøkonomien",
    "Finansieringsforslag til nye aktiver som ejendomme og maskiner",
    "Forberedelse af salg eller generationsskifte af virksomheden",
    "Løbende sparringspartner for ledelsen"
  ];

  return (
    <div className="py-16 bg-white">
      <Helmet>
        <title>Erhvervsrådgivning: Økonomisk rådgivning til virksomheder</title>
        <meta name="description" content="Få et økonomisk overblik i din virksomhed. Finansoptimering ser også gerne på sammenhængen mellem privatøkonomien og erhvervsøkonomien. Se mere her" />
      </Helmet>

      <div className="container mx-auto px-4 max-w-4xl">
        <nav className="text-sm text-slate-500 mb-8 flex items-center space-x-2">
          <Link to="/" className="hover:text-[#b60f00]">Forsiden</Link>
          <span>/</span>
          <span className="text-slate-900 font-medium">Erhvervsrådgivning</span>
        </nav>

        <h1 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-10 break-words">Erhvervsrådgivning</h1>

        <div className="flex flex-col md:flex-row gap-10 mb-12 items-center">
          <div className="md:w-1/2 prose prose-slate prose-lg">
            <h2 className="text-3xl font-bold text-slate-900 mb-6">Optimering af din virksomheds økonomi</h2>
            <p>
              Vi hjælper virksomhedsejere med at skabe overblik over erhvervsøkonomien og dens tætte sammenhæng med privatøkonomien. Vores mål er at sikre de bedste vilkår, minimere risici og skabe størst muligt overskud.
            </p>
          </div>
          <div className="md:w-1/2">
            <img 
              src="https://assets.auxodev.dk/assets/3ae65674-a84a-41bf-9a95-918b20317861/5bf53dce-8684-41c2-8d6e-8d80bcd1e732.jpg" 
              alt="erhvervsrådgivning" 
              className="rounded-3xl shadow-xl w-full"
            />
          </div>
        </div>

        <div className="bg-slate-50 rounded-3xl p-8 md:p-12 border border-slate-200 mb-12">
          <h3 className="text-2xl font-bold text-slate-900 mb-8 flex items-center">
            Vi hjælper din virksomhed med:
          </h3>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
            {competencies.map((item, i) => (
              <li key={i} className="flex items-start">
                <CheckCircle2 size={20} className="text-[#b60f00] mr-3 shrink-0 mt-1" />
                <span className="text-slate-700 leading-relaxed text-sm">{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="text-center">
          <Link 
            to="/kontakt-os" 
            className="inline-flex items-center bg-[#b60f00] text-white px-10 py-5 rounded-2xl text-lg font-bold hover:bg-[#a00d00] transition-all shadow-lg active:scale-95"
          >
            Bestil et gratis uforpligtende møde her
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Erhvervsraadgivning;
